import { HpSvgIconTypes, SvgIcon } from '@avantia/style-guide';
import { resetCustomerSearchAction } from 'actions/index';
import { getYear } from 'date-fns';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { PATH } from 'interfaces/pathTypes';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import './agentBanner.scss';

interface AgentBannerProps {
  selectedPolicy?: FullPolicyData;
  disableSearch?: boolean;
}

export const AgentBanner = ({ selectedPolicy, disableSearch = false }: AgentBannerProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const { searchSuccess, searchResults } = useAppSelector((state) => state.customerSearch);
  const { pathname } = location;

  const isOnSearchPage = pathname === PATH.AGENT_SEARCH;
  const isShowingSearchForm = !(searchSuccess && searchResults && searchResults.length > 0);
  const customerSinceYear =
    selectedPolicy && selectedPolicy.customerSince ? getYear(new Date(selectedPolicy.customerSince)) : '';

  const handleSearchClick = () => {
    dispatch(resetCustomerSearchAction());
    if (!isOnSearchPage) {
      history.push(PATH.AGENT_SEARCH);
    }
  };

  return (
    <Navbar className="agent-search-navbar" fixed="top" expand="lg">
      <Container fluid>
        <Row className="w-100 align-items-center">
          <Col xs={12}>
            <Nav className="agent-search-nav">
              <Nav.Link
                onClick={handleSearchClick}
                className="agent-search-navbar-link"
                disabled={disableSearch || (isShowingSearchForm && isOnSearchPage)}>
                <SvgIcon type="search" size="tiny" />
                SEARCH
              </Nav.Link>
              {selectedPolicy ? (
                <div className="policy-details-text">
                  <p className="banner-text">
                    <span className="bold-text">Customer name: </span>
                    {selectedPolicy.title} {selectedPolicy.forename} {selectedPolicy.surname}
                  </p>
                  <p className="banner-text">{selectedPolicy.email}</p>
                  <p className="banner-text">
                    <span className="bold-text">Policy number:</span> {selectedPolicy.policyNumber}
                  </p>
                  {customerSinceYear && (
                    <p className="banner-text">
                      <span className="bold-text">Customer since:</span> {customerSinceYear}
                    </p>
                  )}
                </div>
              ) : (
                <p className="banner-text bold-text">Welcome to the Homeprotect customer portal agent view</p>
              )}
              <Nav.Link href="/" className="agent-search-navbar-link" disabled>
                <SvgIcon type={'chart-line' as HpSvgIconTypes} size="tiny" />
                POLICY ACTIVITY
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};
